/**
 * 选择拖动时，自动滚动
 */

import { useEffect } from "react";
import { CalculatedColumn, DataGridRef, ISelectRange, Position } from "../types";
import { ISelectorEvent } from "../types";

const SCROLL_THROTTLE_TIME = 16;

export function useSelectScroll(
    isMouseInElement: boolean,
    mouseLeaveEvent: MouseEvent | null,
    isMouseDown: boolean,
    gridRef: React.RefObject<HTMLDivElement>,
    selectedRange: ISelectRange,
    colVisibleStartIdx: number,
    colVisibleEndIdx: number,
    gridWidth: number,
    gridHeight: number,
    handleSelect: (event: ISelectorEvent) => void,
    refContext: DataGridRef,
    rowVisibleStartIdx: number,
    rowVisibleEndIdx: number,
    rows: DataGridRef["rows"],
    columns: CalculatedColumn<any, any>[],
    scrollToCell: (position: Partial<Position>, force?: boolean) => void
) {
    useEffect(() => {
        const timerSet = new Set<number>()
        if (isMouseInElement) return;
        const gridRect = gridRef.current?.getBoundingClientRect();
        if (mouseLeaveEvent && isMouseDown && gridRect) {
            const { x, y } = gridRect;
            const { clientX, clientY } = mouseLeaveEvent;
            const offsetX = clientX - x;
            const offsetY = clientY - y;
            const { endColumnIdx, endRowIdx } = selectedRange;
            if (offsetX <= 10) {
                const nextIdx = colVisibleStartIdx - 1;
                if (nextIdx > 0) {
                    timerSet.add(setInterval(() => {
                        scrollToCell({ columnIdx: nextIdx })
                        handleSelect({
                            rowIdx: endRowIdx,
                            columnIdx: nextIdx,
                            isUpdateIndex: false
                        })
                    }, SCROLL_THROTTLE_TIME * 4))
                }
            }
            if (offsetX > gridWidth) {
                const nextIdx = colVisibleEndIdx + 1;
                if (nextIdx <= columns.length - 1) {
                    timerSet.add(setInterval(() => {
                        scrollToCell({ columnIdx: nextIdx })

                        handleSelect({
                            rowIdx: endRowIdx,
                            columnIdx: nextIdx,
                            isUpdateIndex: false
                        })

                    }, SCROLL_THROTTLE_TIME * 4))
                }
            }
            if (offsetY <= 10) {
                const nextRowIdx = rowVisibleStartIdx - 1;
                if (nextRowIdx > -1) {
                    timerSet.add(setInterval(() => {
                        refContext.scrollToRow(nextRowIdx)

                        handleSelect({
                            rowIdx: nextRowIdx,
                            columnIdx: endColumnIdx,
                            isUpdateIndex: false
                        })
                    }, SCROLL_THROTTLE_TIME))
                }
            }
            if (offsetY >= gridHeight) {
                const nextRowIdx = rowVisibleEndIdx + 1;
                timerSet.add(setInterval(() => {
                    refContext.scrollToRow(rowVisibleStartIdx + 1, true)
                    if (nextRowIdx <= rows.length - 1) {
                        handleSelect({
                            rowIdx: rowVisibleEndIdx + 1,
                            columnIdx: endColumnIdx,
                            isUpdateIndex: false
                        })
                    }
                }, SCROLL_THROTTLE_TIME))
            }
        }
        return () => {
            timerSet.forEach(clearInterval)
        }
    }, [gridRef, isMouseInElement, selectedRange, mouseLeaveEvent, isMouseDown, rowVisibleStartIdx, rowVisibleEndIdx, colVisibleStartIdx, colVisibleEndIdx, gridWidth, gridHeight, handleSelect, refContext, rows, columns])

}
